import { useEffect, useState } from 'react';
import { authFetch } from '../services/authApi';

// Returns the org's competition state for this discipline:
//   { competitions, participates }
// - competitions: currently-live events (drives the hero + badge)
// - participates: whether the org is in ANY competition (past/live/upcoming),
//   which gates whether the Competitions tab is shown at all.
// Until apps/competitions ships, the endpoint 404s and we return the empty,
// non-participating state so the dashboard looks exactly as it does today.
export function useActiveCompetitions(discipline = 'skill_exam') {
  const [state, setState] = useState({ competitions: [], participates: false });

  useEffect(() => {
    let cancelled = false;
    authFetch(`/api/competitions/active/?discipline=${discipline}`)
      .then((data) => {
        if (cancelled) return;
        const list = data?.results || (Array.isArray(data) ? data : []);
        const competitions = Array.isArray(list) ? list : [];
        const participates = data?.participates ?? competitions.length > 0;
        setState({ competitions, participates });
      })
      .catch(() => {
        if (!cancelled) setState({ competitions: [], participates: false });
      });
    return () => { cancelled = true; };
  }, [discipline]);

  return state;
}
